import {
  InitOrderProductsParams,
  InitSectionsParams,
} from '../interfaces/orderProducts.helper.interfaces';
import { OrderHeadersGroupByEnum, OrderProduct, Section } from '../orderProducts.types';
import OrderProductsGroupByFactory from './groupBy/OrderProductsGroupByFactory';
import { emptyDefaultSection } from './orderProductsHelpers.utils';
import OrderProductsSorterFactory from './sorter/OrderProductsSorterFactory';

export const initSections = ({
  products,
  view,
  viewInfo,
  pendingOrderProductKeys,
}: InitSectionsParams): Section[] => {
  const orderProductsGroupBy = new OrderProductsGroupByFactory().create(view);
  const orderProductsSorter = new OrderProductsSorterFactory().create(view);
  const sections = orderProductsGroupBy.group({
    orderProducts: products,
    info: viewInfo,
    pendingOrderProductKeys,
  });

  if (view[0] === OrderHeadersGroupByEnum.DEFAULT) {
    return orderProductsSorter.sort({ orderProducts: sections });
  }
  return [
    emptyDefaultSection,
    ...orderProductsSorter.sort({
      orderProducts: sections,
      pendingOrderProductKeys,
      info: viewInfo,
    }),
  ];
};

export const sortOrderProducts = ({
  products,
  view,
  pendingOrderProductKeys,
  viewInfo,
}: InitOrderProductsParams): OrderProduct[] => {
  const orderProductsSorter = new OrderProductsSorterFactory().create(view);
  return orderProductsSorter.sort({
    orderProducts: products,
    pendingOrderProductKeys,
    info: viewInfo,
  });
};

export const initOrderProducts = ({ products, ...params }: InitOrderProductsParams) =>
  sortOrderProducts({
    ...params,
    products: products.map((product) => ({
      ...product,
      subCategory: product.category,
    })),
  });
